import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<LightBoxConfirm>({
  components: {}
})
export default class LightBoxConfirm extends Vue {
    // prop in
    @PropSync("show", { type: Boolean })
    syncedShow!: boolean;
    @PropSync("title", { type: String })
    syncedTitle!: string;
    @PropSync("txt", { type: String })
    syncedTxt!: string;
    @PropSync("cancel", { type: String })
    syncedCancel!: string;
    @PropSync("confirm", { type: String })
    syncedConfirm!: string;

    // event out
    private cancelEvent() {
        this.$emit("closeLightBoxConfirm"); // 觸發的事件名稱
    }

    private confirmEvent() {
        this.$emit("confirmLightBoxConfirm"); // 觸發的事件名稱
    }
}